module.exports = __webpack_public_path__ + "img/de-praktijk-4.fb270ddd.jpg";